import Api from 'app/services/Api';

const resource = 'business-doc';

export function getDoc(params) {
  return Api.get(resource, { params });
}
